var r = /* @__PURE__ */ ((X) => (X[X.XXS = 12] = "XXS", X[X.XS = 16] = "XS", X[X.SM = 20] = "SM", X[X.MD = 24] = "MD", X[X.LG = 32] = "LG", X))(r || {});
export {
  r as IconSize
};
